export const moreCourses = [
    {
        id: "solidworks-api",
        name: "SolidWorks API",
        title: "Learn SolidWorks Customization & Automation API using C#.NET",
        description:
            "Learn SolidWorks customization and automation using C#.NET and API programming.",
        url: "/solidworks-api-customization-automation-training"
    },

    {
        id: "catia-caa",
        name: "CATIA CAA",
        title: "Learn CATIA Automation & Customization Training",
        description:
            "Learn CATIA automation and customization using CATIA CAA and programming.",
        url: "/catia-caa-customization-automation-training"
    },

    {
        id: "revit-bim",
        name: "Autodesk Revit BIM",
        title: "Learn Revit BIM Automation & Customization Training",
        description:
            "Learn Revit BIM automation and customization for real-world engineering workflows.",
        url: "/autodesk-revit-api-customization-automation-course"
    },

    {
        id: "creo-toolkit",
        name: "Creo Toolkit",
        title: "Learn CREO Customization & Automation using Creo Toolkit",
        description:
            "Learn CREO customization and automation using Creo Toolkit and programming.",
        url: "/creo-toolkit-customization-training"
    },

    {
        id: "autocad-net",
        name: "AutoCAD .NET API",
        title: "Learn AutoCAD Automation & Customization Training",
        description:
            "Learn AutoCAD customization and automation using the AutoCAD .NET API.",
        url: "/autocad-api-customization-automation-online-courses"
    },

    {
        id: "inventor-api",
        name: "Autodesk Inventor API",
        title: "Learn Autodesk Inventor Automation & Customization API Training",
        description:
            "Learn Autodesk Inventor automation and customization using API programming.",
        url: "/autodesk-inventor-api-customization-automation-course"
    }
];